<div class="modal-header">
  <h5 class="card-title" i18n>Chat with partner</h5>
  <button type="button" class="btn-close" (click)="activeModal.close()"></button>
</div>

<div class="modal-body">
  <div class="chat-container">
    <div class="card flex-grow-1 messages-wrapper">
      <div class="messages-area" #messagesContainer [scrollTop]="messagesContainer.scrollHeight">
        <div #messagesBox class="card-body">
          <div *ngFor="let message of messages" class="m-2">
            <div class="row">
              <div class="p-0" style="width: 3rem; height: 3.5rem;">
                <img *ngIf="message.from_contact" [src]="message.from_contact.picture"
                  style="border-radius: 50%; width: 3rem; height: 3rem;" class="pr-3">
                <img *ngIf="message.from_employee" [src]="message.from_employee.picture"
                  style="border-radius: 50%; width: 3rem; height: 3rem;" class="pr-3">
                <img *ngIf="message.from_user" [src]="message.from_user.picture"
                  style="border-radius: 50%; width: 3rem; height: 3rem;" class="pr-3">
              </div>
              <div class="col align-middle">
                <span class="float-end text-muted">
                  {{ message.created_at | date: 'short' }}
                </span>
                <div class="text-info" *ngIf="message.from_contact">{{ message.from_contact.first_name }}</div>
                <div class="text-info" *ngIf="message.from_employee">{{ message.from_employee.first_name }}</div>
                <div class="text-info" *ngIf="message.from_user">{{ message.from_user | translateField: 'screen_name'}}
                </div>
                <div class="" style="display: inline-block; white-space: pre-wrap;"
                  [ngClass]="{ 'text-muted': message.blocked, 'text-decoration-line-through': message.blocked }"
                  [innerHTML]="links(message | translateField: 'message')">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Input Area -->
      <div class="card-footer input-area">
        <form class="d-flex">
          <div #message (keydown.enter)="handleEnterKey($event)"
            [attr.placeholder]="firstMessageSent ? '' : placeholderText" contenteditable="true"
            class="textarea form-control mx-2" enterkeyhint="enter" style="border-color: #fff;"></div>
          <button type="button" class="btn btn-primary text-nowrap align-self-end h-auto" (click)="send()">
            <span class="d-none d-sm-inline me-1" i18n>Send</span>
            <fa-icon [icon]="fa.faPaperPlane" class="plane-sm-hack" style="color: #fff;"></fa-icon>
          </button>
        </form>
      </div>
    </div>
  </div>
</div>